import { render, staticRenderFns } from "./PopupForLanding.vue?vue&type=template&id=7189caf1&scoped=true"
import script from "./PopupForLanding.vue?vue&type=script&lang=js"
export * from "./PopupForLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7189caf1",
  null
  
)

export default component.exports